import { InteractionRequiredAuthError } from '@azure/msal-browser';

// This is the specific scope for backend API
const apiScopes = ["api://fdff9b73-dad5-40b1-b0e3-ef8396f39b72/access_as_user"];

/**
 * Acquires an access token for the backend API.
 * Handles silent acquisition and interactive fallback.
 * @param {object} msalInstance - The MSAL PublicClientApplication instance.
 * @param {object} account - The active user account.
 * @returns {Promise<string>} The access token.
 */
export const getApiToken = async (msalInstance, account) => {
  if (window.__E2E_TEST__) {
    return 'e2e-test-token';
  }

  if (!account) {
    throw new Error("No active account available for authentication.");
  }

  try {
    const accessTokenResponse = await msalInstance.acquireTokenSilent({
      scopes: apiScopes,
      account: account,
    });
    return accessTokenResponse.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      // Fallback to interactive token acquisition if silent fails
      await msalInstance.acquireTokenRedirect({ scopes: apiScopes });
    }
    // Re-throw other errors to be handled by the caller
    throw error;
  }
};